import { render, staticRenderFns } from "./piechart.component.vue?vue&type=template&id=8f03c29a"
import script from "./piechart.component.vue?vue&type=script&lang=js"
export * from "./piechart.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports